import { Alert, Button, Form, Modal, Row, Space, Steps, message } from 'antd'
import { ModalProps } from 'antd/lib/modal'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import { ImportModalType } from '../../../pages/toSubmitGoods/reducer'
import RelationProjectCheckGroup from '../../../components/RelationProjectCheckGroup'
import SingleUpload from '../../../components/SingleUpload'
import { isExcel, isZip } from '../../../tools/regex'
import { RcFile } from 'antd/lib/upload'
export function validateZip(file: RcFile) {
  if (!isZip(file.name)) {
    message.warning('请选择zip压缩包格式的文件')
    return false
  }
  return true
}
export function validateExcel(file: RcFile) {
  if (!isExcel(file.name)) {
    message.warning('请选择excel格式的文件')
    return false
  }
  return true
}
export interface Props extends ModalProps {
  title: ImportModalType
  productIds: string[]
  productType?: string
  onImportSuccess: () => void
}
const stepList = [
  {
    title: '',
    description: '下载模板',
  },
  {
    title: '',
    description: '导入文件',
  },
]

export default function ImportProjectModal(props: Props) {
  const { title, productType } = props
  const {
    state,
    relationProjectForm,
    handleDownloadTemplate,
    handleStepChange,
    handleImportClick,
  } = useSetupHook(props)
  const { currentStep, loadingState } = state

  function renderContent() {
    switch (title as ImportModalType) {
      case '导入上架项目':
        return (
          <div className={styles['inner-container']}>
            <div>
              {currentStep === 0 ? (
                <div>
                  <div className={styles['alert']}>
                    <Alert
                      message="新导入的字段会覆盖原有填写的项目字段"
                      type="info"
                      showIcon
                    />
                  </div>
                  <Form form={relationProjectForm}>
                    <Form.Item
                      label="关联项目"
                      name={'relationProject'}
                      required
                    >
                      <RelationProjectCheckGroup
                        onDownloadTemplate={() => handleDownloadTemplate()}
                        productType={productType}
                      ></RelationProjectCheckGroup>
                    </Form.Item>
                  </Form>
                </div>
              ) : null}
              {currentStep === 1 ? (
                <Form form={relationProjectForm}>
                  <Form.Item name="file" label="导入文件">
                    <SingleUpload></SingleUpload>
                  </Form.Item>
                </Form>
              ) : null}
            </div>
          </div>
        )
      case '导入图片':
        return (
          <div className={styles['inner-container']}>
            {currentStep === 0 ? (
              <div>
                <div className={styles['alert']}>
                  <Alert
                    message="新导入的图片会覆盖原有的图片，请将图片放到物料编码的文件夹内，并主图用z1,z2,z3……zn命名，详情图用xq1,xq2,xq3……xqn命名"
                    type="info"
                    showIcon
                  />
                </div>
                <span className="btn-link" onClick={handleDownloadTemplate}>
                  下载导入模板.zip
                </span>
              </div>
            ) : null}
            {currentStep === 1 ? (
              <Form form={relationProjectForm}>
                <Form.Item name="file" label="导入文件">
                  <SingleUpload
                    accept="application/zip"
                    customProps={{
                      tips: '支持zip压缩包格式',
                      validateFile: validateZip,
                      canPreview: false,
                    }}
                  ></SingleUpload>
                </Form.Item>
              </Form>
            ) : null}
          </div>
        )
      case '导入拓展属性':
        return (
          <div className={styles['inner-container']}>
            <div>
              {currentStep === 0 ? (
                <div>
                  <div className={styles['alert']}>
                    <Alert
                      message="新导入的字段会覆盖原有填写的拓展属性"
                      type="info"
                      showIcon
                    />
                  </div>
                  <span className="btn-link" onClick={handleDownloadTemplate}>
                    下载导入模板.xlsx
                  </span>
                </div>
              ) : null}
              {currentStep === 1 ? (
                <Form form={relationProjectForm}>
                  <Form.Item name="file" label="导入文件">
                    <SingleUpload></SingleUpload>
                  </Form.Item>
                </Form>
              ) : null}
            </div>
          </div>
        )
      case '导入资质图片':
        return (
          <div className={styles['inner-container']}>
            {currentStep === 0 ? (
              <div>
                <span className="btn-link" onClick={handleDownloadTemplate}>
                  下载导入模板.zip
                </span>
              </div>
            ) : null}
            {currentStep === 1 ? (
              <Form form={relationProjectForm}>
                <Form.Item name="file" label="导入文件">
                  <SingleUpload
                    accept="application/zip"
                    customProps={{
                      tips: '支持zip压缩包格式',
                      validateFile: validateZip,
                      canPreview: false,
                    }}
                  ></SingleUpload>
                </Form.Item>
              </Form>
            ) : null}
          </div>
        )
    }
  }
  return (
    <Modal
      {...props}
      footer={
        <Row justify="end">
          <Space>
            <Button size="middle" onClick={props?.onCancel}>
              取消
            </Button>
            {currentStep === 0 ? (
              <Button
                size="middle"
                type="primary"
                onClick={() => handleStepChange(currentStep + 1)}
              >
                下一步
              </Button>
            ) : null}
            {currentStep === 1 ? (
              <>
                {title === '导入图片' && (
                  <Button
                    size="middle"
                    onClick={() => handleStepChange(currentStep - 1)}
                  >
                    上一步
                  </Button>
                )}
                <Button
                  size="middle"
                  type="primary"
                  onClick={handleImportClick}
                  loading={loadingState.isImportLoading}
                >
                  导入
                </Button>
              </>
            ) : null}
          </Space>
        </Row>
      }
    >
      <div className={styles['container']}>
        <div className={styles['steps-container']}>
          <Steps labelPlacement="vertical" size="small" current={currentStep}>
            {stepList.map((item) => {
              return (
                <Steps.Step
                  key={item.description}
                  title={item.description}
                ></Steps.Step>
              )
            })}
          </Steps>
        </div>
        <div className={styles['content-container']}>{renderContent()}</div>
      </div>
    </Modal>
  )
}
import { Alert, Button, Form, Modal, Row, Space, Steps, message } from 'antd'
import { ModalProps } from 'antd/lib/modal'
import { useSetupHook } from './hooks'
import styles from './styles.module.scss'
import { ImportModalType } from '../../../pages/toSubmitGoods/reducer'
import RelationProjectCheckGroup from '../../../components/RelationProjectCheckGroup'
import SingleUpload from '../../../components/SingleUpload'
import { isExcel, isZip } from '../../../tools/regex'
import { RcFile } from 'antd/lib/upload'
export function validateZip(file: RcFile) {
  if (!isZip(file.name)) {
    message.warning('请选择zip压缩包格式的文件')
    return false
  }
  return true
}
export function validateExcel(file: RcFile) {
  if (!isExcel(file.name)) {
    message.warning('请选择excel格式的文件')
    return false
  }
  return true
}
export interface Props extends ModalProps {
  title: ImportModalType
  productIds: string[]
  productType?: string
  onImportSuccess: () => void
}
const stepList = [
  {
    title: '',
    description: '下载模板',
  },
  {
    title: '',
    description: '导入文件',
  },
]

export default function ImportProjectModal(props: Props) {
  const { title, productType } = props
  const {
    state,
    relationProjectForm,
    handleDownloadTemplate,
    handleStepChange,
    handleImportClick,
  } = useSetupHook(props)
  const { currentStep, loadingState } = state

  function renderContent() {
    switch (title as ImportModalType) {
      case '导入上架项目':
        return (
          <div className={styles['inner-container']}>
            <div>
              {currentStep === 0 ? (
                <div>
                  <div className={styles['alert']}>
                    <Alert
                      message="新导入的字段会覆盖原有填写的项目字段"
                      type="info"
                      showIcon
                    />
                  </div>
                  <Form form={relationProjectForm}>
                    <Form.Item
                      label="关联项目"
                      name={'relationProject'}
                      required
                    >
                      <RelationProjectCheckGroup
                        onDownloadTemplate={() => handleDownloadTemplate()}
                        productType={productType}
                      ></RelationProjectCheckGroup>
                    </Form.Item>
                  </Form>
                </div>
              ) : null}
              {currentStep === 1 ? (
                <Form form={relationProjectForm}>
                  <Form.Item name="file" label="导入文件">
                    <SingleUpload></SingleUpload>
                  </Form.Item>
                </Form>
              ) : null}
            </div>
          </div>
        )
      case '导入图片':
        return (
          <div className={styles['inner-container']}>
            {currentStep === 0 ? (
              <div>
                <div className={styles['alert']}>
                  <Alert
                    message="新导入的图片会覆盖原有的图片，请将图片放到物料编码的文件夹内，并主图用z1,z2,z3……zn命名，详情图用xq1,xq2,xq3……xqn命名"
                    type="info"
                    showIcon
                  />
                </div>
                <span className="btn-link" onClick={handleDownloadTemplate}>
                  下载导入模板.zip
                </span>
              </div>
            ) : null}
            {currentStep === 1 ? (
              <Form form={relationProjectForm}>
                <Form.Item name="file" label="导入文件">
                  <SingleUpload
                    accept="application/zip"
                    customProps={{
                      tips: '支持zip压缩包格式',
                      validateFile: validateZip,
                      canPreview: false,
                    }}
                  ></SingleUpload>
                </Form.Item>
              </Form>
            ) : null}
          </div>
        )
      case '导入拓展属性':
        return (
          <div className={styles['inner-container']}>
            <div>
              {currentStep === 0 ? (
                <div>
                  <div className={styles['alert']}>
                    <Alert
                      message="新导入的字段会覆盖原有填写的拓展属性"
                      type="info"
                      showIcon
                    />
                  </div>
                  <span className="btn-link" onClick={handleDownloadTemplate}>
                    下载导入模板.xlsx
                  </span>
                </div>
              ) : null}
              {currentStep === 1 ? (
                <Form form={relationProjectForm}>
                  <Form.Item name="file" label="导入文件">
                    <SingleUpload></SingleUpload>
                  </Form.Item>
                </Form>
              ) : null}
            </div>
          </div>
        )
      case '导入资质图片':
        return (
          <div className={styles['inner-container']}>
            {currentStep === 0 ? (
              <div>
                <span className="btn-link" onClick={handleDownloadTemplate}>
                  下载导入模板.zip
                </span>
              </div>
            ) : null}
            {currentStep === 1 ? (
              <Form form={relationProjectForm}>
                <Form.Item name="file" label="导入文件">
                  <SingleUpload
                    accept="application/zip"
                    customProps={{
                      tips: '支持zip压缩包格式',
                      validateFile: validateZip,
                      canPreview: false,
                    }}
                  ></SingleUpload>
                </Form.Item>
              </Form>
            ) : null}
          </div>
        )
    }
  }
  return (
    <Modal
      {...props}
      footer={
        <Row justify="end">
          <Space>
            <Button size="middle" onClick={props?.onCancel}>
              取消
            </Button>
            {currentStep === 0 ? (
              <Button
                size="middle"
                type="primary"
                onClick={() => handleStepChange(currentStep + 1)}
              >
                下一步
              </Button>
            ) : null}
            {currentStep === 1 ? (
              <>
                {title === '导入图片' && (
                  <Button
                    size="middle"
                    onClick={() => handleStepChange(currentStep - 1)}
                  >
                    上一步
                  </Button>
                )}
                <Button
                  size="middle"
                  type="primary"
                  onClick={handleImportClick}
                  loading={loadingState.isImportLoading}
                >
                  导入
                </Button>
              </>
            ) : null}
          </Space>
        </Row>
      }
    >
      <div className={styles['container']}>
        <div className={styles['steps-container']}>
          <Steps labelPlacement="vertical" size="small" current={currentStep}>
            {stepList.map((item) => {
              return (
                <Steps.Step
                  key={item.description}
                  title={item.description}
                ></Steps.Step>
              )
            })}
          </Steps>
        </div>
        <div className={styles['content-container']}>{renderContent()}</div>
      </div>
    </Modal>
  )
}
